import React from 'react';
import PropTypes from 'prop-types';
import { LocaleService } from '@sm360/widget-commons-core-services';

import 'inventory-listing/components/ListingResults/ListingResults.scss';

class ListingResults extends React.Component {
    shouldComponentUpdate({ isLoading }) {
        return !isLoading;
    }
    render() {
        const { currentCount, totalCount, listingUrl, isLoading } = this.props;

        const labelParams = {
            currentCount,
            totalCount,
            listingUrl,
        };

        if (isLoading) {
            return null;
        }

        let result;
        switch (currentCount) {
            case 0:
                result = LocaleService.t('RESULTS_FOR_ZERO', {
                    currentCount,
                    totalCount,
                    listingUrl,
                });
                break;
            case 1:
                result = LocaleService.t('RESULTS_FOR_ONE', labelParams);
                break;
            case totalCount:
                result = LocaleService.t('RESULTS_FOR_TOTAL', { totalCount });
                break;
            default:
                result = LocaleService.t('RESULTS_FOR', labelParams);
                break;
        }
        return (
            <div className="listing-used-results">
                <div className="number-results" dangerouslySetInnerHTML={{ __html: result }} />
            </div>
        );
    }
}

ListingResults.propTypes = {
    currentCount: PropTypes.number.isRequired,
    totalCount: PropTypes.number.isRequired,
    listingUrl: PropTypes.string.isRequired,
    isLoading: PropTypes.bool.isRequired,
};

ListingResults.displayName = 'ListingResults';

export default ListingResults;
